import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomSpinner from "../../spinner/CustomSpinner";
import "./SubmitSection.scss";
import { SubmitSectionOptionalProps } from "./submitSectionProps";

const SubmitSection: React.FC<SubmitSectionOptionalProps> = ({
  btnName = "",
  isLoading = false,
  showBackBtn = true,
  showCancelBtn = true,
  showApproveBtn = true,
  disableApproveBtn = false,
  onSubmit,
  onBack,
  onCancel,
}) => {
  const { t } = useTranslation();
  const navData = useNavigate();

  const isSubmitButtonEnabled = useCallback(
    () => !disableApproveBtn && !(isLoading ?? false),
    [disableApproveBtn, isLoading]
  );

  const handleSubmitButtonClick = useCallback(() => {
    if (onSubmit && isSubmitButtonEnabled()) {
      onSubmit();
    }
  }, [isSubmitButtonEnabled, onSubmit]);

  return (
    <div className="submitSection-wrapper">
      <button
        type="button"
        onClick={onBack ? () => onBack() : () => navData(-1)}
        className={`alt-btn alt-btn-arrow-left ${showBackBtn ? "visible" : "invisible"}`}
      >
        {t("buttons.back")}
      </button>
      <button
        type="button"
        className={`alt-btn alt-btn-luk ${showCancelBtn ? "d-block" : "d-none"}`}
        onClick={() => onCancel?.()}
      >
        {t("buttons.cancel")}
      </button>
      <div className="submitButton has-spinner">
        <button
          type="button"
          className={`
            ${isLoading ? "btn btn-primary loading" : "btn btn-primary"}
            ${showApproveBtn ? "d-block" : "d-none"}`}
          onClick={handleSubmitButtonClick}
          disabled={!isSubmitButtonEnabled()}
        >
          {btnName ? btnName : t("buttons.approve")}
          {isLoading && <CustomSpinner isButton={true} />}
        </button>
      </div>
    </div>
  );
};

export default SubmitSection;
